export default {
  colors: {
    black: "#000000",
    white: "#ffffff",
    yellow: "#f8981d",

    lightBlue: "#8cd5f6",
    backgroundColor: "#f7f7f7",
    orange: "#FC4C02",
    orangeDarker: "#b72009",
    grayDarker: "#565252",
    grayDark2: "#606060",
    grayDark: "#808080",
    gray: "#a2a2a2",
    borderColor: "#d1d3d4",
    borderColorLight: "rgba(0, 0, 0, 0.1)"
  }
};
